<template>
  <button
    class="hidden fixed bottom-24 left-0 md:flex items-center justify-center border py-2 px-1 border-l-0 shadow-lg text-sm font-medium rounded-r-md focus:outline-none border-gray-300 text-gray-700 bg-white hover:bg-gray-50"
    @click="$emit('click')"
  >
    <SolidChatAlt2Icon class="h-5 w-5 text-gray-500 hover:text-blue" />
  </button>
</template>

<script>
export default {
  emits: ['click'],
}
</script>
